import { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { useTIFFormData } from "../../../../hooks";
import { getValueOrBlank, displayDateAndTime } from "../../../../helper-functions";
import PhotoThumbnail from "../../../photos/PhotoThumbnail";
import { TissueTypes } from "../../../../models";
import { AutoCol } from "../../../../component-library";
import { TissueInformationFormProps } from ".";

export function TIFInitialGradingNoProcedure({ tissueId }: Readonly<TissueInformationFormProps>) {
    const {
        fetchGradingCaseFileUrls,
        initialGradingFiles,
        caseFileUrls,
        initialEvalSummary,
        getSuitability,
        latestInitialGradingSlitLamp,
        latestInitialGradingSpecular,
        tissue,
    } = useTIFFormData({ tissueId });

    const isWholeGlobe = tissue?.tissueType?.name === TissueTypes.WholeGlobe;

    useEffect(() => {
        fetchGradingCaseFileUrls(initialGradingFiles);
    }, [fetchGradingCaseFileUrls, initialGradingFiles]);

    if (!tissue) {
        return <div>No tissue found</div>;
    }

    return (
        <div>
            <Row>
                <Col>
                    <div style={{ fontWeight: "bold" }}>{tissue?.tissueType?.name} Evaluation: </div>
                    {!isWholeGlobe && (
                        <>
                            <div>
                                Endothelial Cell Density: {getValueOrBlank(tissue?.initialEval?.data?.cellDensity)}{" "}
                                Cells/sq mm
                            </div>
                            <div>Cornea Diameter: {getValueOrBlank(tissue?.initialEval?.data?.cornealDiameter)} mm</div>
                            <div>
                                CS Rim: {getValueOrBlank(tissue?.initialEval?.data?.corneoscleralRimSize1)} -{" "}
                                {getValueOrBlank(tissue?.initialEval?.data?.corneoscleralRimSize2)} mm
                            </div>
                            {!!tissue?.initialEval?.data?.clearZoneNa && <div>Primary Clear Zone: N/A.</div>}
                            {!tissue?.initialEval?.data?.clearZoneNa && !!tissue?.initialEval?.data?.newClearZone && (
                                <div>
                                    Primary Clear Zone: {tissue?.initialEval?.data?.newClearZone}{" "}
                                    {getValueOrBlank(tissue?.initialEval?.data?.clearZoneSize)} mm
                                </div>
                            )}
                            {!!tissue?.initialEval?.data?.endothelialNa && <div>Endothelial Clear Zone: N/A.</div>}
                            {!tissue?.initialEval?.data?.endothelialNa && !!tissue?.initialEval?.data?.endothelial && (
                                <div>
                                    Endothelial Clear Zone: {getValueOrBlank(tissue?.initialEval?.data?.endothelial)} mm
                                </div>
                            )}
                        </>
                    )}
                    <div>Lens: {getValueOrBlank(tissue?.initialEval?.data?.lensStatus)}</div>
                </Col>
                {initialGradingFiles.map((cf) => (
                    <AutoCol key={cf.id}>
                        <PhotoThumbnail
                            caseFile={cf}
                            url={caseFileUrls[cf.id]}
                            maxHeight="110px"
                            maxWidth="150px"
                            className="m-0"
                        />
                    </AutoCol>
                ))}
            </Row>
            <Row>{initialEvalSummary}</Row>
            <Row>
                <Col>Suitability: {tissue?.initialEval?.data?.suitability?.checked === "yes" && getSuitability()}</Col>
            </Row>
            <Row>
                <Col>
                    <span className="me-2">
                        Slit Lamp Date/Time: {displayDateAndTime(latestInitialGradingSlitLamp?.createdOn)}
                    </span>
                    <span className="me-3">Slit Lamp Tech: {latestInitialGradingSlitLamp?.createdByUserName}</span>
                    <span className="me-2">
                        Specular Date/Time: {displayDateAndTime(latestInitialGradingSpecular?.createdOn)}
                    </span>
                    <span>Specular Tech: {latestInitialGradingSpecular?.createdByUserName}</span>
                </Col>
            </Row>
        </div>
    );
}
